<template>
    <div class="dml-top-products" data-t="24.5">
        <h3 class="dml-top-products__heading">
            <span>TOP 20:</span>
            <a :href="url"
               :rel="rel"
               data-ga="m_home.click_top_products_heading"
               :data-ga-label="urlLabel">{{urlLabel}}</a>
        </h3>
        <dm-scrollable-list className="dml-product-carousel"
                            innerClassName="dml-product-carousel__list"
                            navClassName="dml-product-carousel__nav"
                            :visibleIndicators="6"
                            :mobileItemsInViewport="2"
                            :tabletItemsInViewport="4"
                            :itemsInViewport="5">
            <template slot="items">
                <li class="dml-product-carousel__item"
                    v-for="(item, index) in productList"
                    :key="index"
                    data-ga="m_home.click_top_product"
                    :data-ga-label="urlLabel">
                    <dm-product-item :model="item" />
                </li>
            </template>
        </dm-scrollable-list>
    </div>
</template>
<script>
    import ScrollableListComponent from '../shared/scrollable-list-component.vue';
    import ProductItem from '../product-list/product-item-component';

    export default {
        name: 'dm-top-products',
        components: {
            'dm-product-item': ProductItem,
            'dm-scrollable-list': ScrollableListComponent,
        },
        props: {
            products: Array,
            rel: String,
            url: String,
            urlLabel: String
        },
        computed: {
            productList() {
                return this.products.map(item => {
                    const props = {
                        price: item.priceText,
                        oldPrice: item.oldPriceText
                    };
                    return Object.assign({}, item, props);
                });
            }
        },
    };
</script>
